import PageHeader from "../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import PathChanger from "../../../components/PagesComponents/Setting/Profile/PathChanger.component";
// import { ReactComponent as AdminInfoIcon } from "../../../assets/Icons/Setting/Profile/AdminInfoIcon.svg";
import { ReactComponent as CoActAdmin } from "../../../assets/Icons/Setting/Permission/Co-Admin/CoActAdmin.svg";
import { ReactComponent as CoActSubAdmin } from "../../../assets/Icons/Setting/Permission/Co-Admin/CoActSubAdmin.svg";
import { Helmet } from "react-helmet";

const Body = ({
  currentTab,
  handelCurrentTab,
  intituteIcons,
  institutePathName,
  institutePaths,
}) => {
  return (
    <div
      className="flex-col align-start justify-start g-1 overflow-hide   "
      style={{ height: "calc(90vh - 1rem)" }}
    >
      <Helmet>
        <title>Permission</title>
      </Helmet>
      <PageHeader />

      <div className="w-full overflow-hide flex-row align-start justify-start g-1 flex-1 ">
        {/* left container */}
        <div
          className=" flex-col align-start justify-between g-1 h-full"
          style={{ width: "18rem" }}
        >
          <div
            className="w-full flex-col align-start justify-start p-2 back-white radius-10"
            style={{ gap: "1.2rem", padding: "1.2rem" }}
          >
            <h4 className="t-15 poppins-medium weight-500">Manage co-admin</h4>
            <div className="w-full flex-col-align-start-justify-start g-05">
              <PathChanger
                title={"Act admin"}
                icon={
                  <CoActAdmin
                    className={
                      currentTab === "coActAdmin"
                        ? "activeSettingPathChangerBtnIcon"
                        : ""
                    }
                  />
                }
                pathName={"coActAdmin"}
              />

              <PathChanger
                title={"Sub admin"}
                icon={
                  <CoActSubAdmin
                    className={
                      currentTab === "coSubAdmin"
                        ? "activeSettingPathChangerBtnIcon"
                        : ""
                    }
                  />
                }
                pathName={"coSubAdmin"}
              />
            </div>
          </div>
          {/* middle block */}
          <div
            className="w-full flex-1 flex-col align-start justify-start p-2 back-white radius-10"
            style={{ gap: "1.2rem", padding: "1.2rem" }}
          >
            <h4 className="t-15 poppins-medium weight-500">Vertical access</h4>
            <div className="w-full flex-col-align-start-justify-start g-05">
              {institutePaths.map((title) => {
                return (
                  <PathChanger
                    title={title}
                    icon={intituteIcons[title]}
                    pathName={institutePathName[title]}
                  />
                );
              })}
            </div>
          </div>
        </div>

        {/* right container */}
        <div className="flex-col align-start justify-start flex-1  scroll-y pr-1 h-full">
          {handelCurrentTab()}
        </div>
      </div>
    </div>
  );
};

export default Body;
